

const AgenceReducer = (state, action) => {
    switch (action.type) {
        case "GET_AGENCES_BY_WILAYA_SUCCESS":
            return {
                ...state,
                agencesByWilaya: action.payload.agences,
            };
        default:
            return { ...state };
    }
}

export default AgenceReducer;
